import React, { useContext, useEffect, useState } from "react"
import classNames from "@utils/classnames"

import Modal from "react-modal"
import Section from "@components/section"
import Tasks from "@components/tasks"
import Button from "@components/button"
import Clickable from "@components/clickable"
import ClickableImage from "@components/clickableImage"

import styles from "./monsterHunter.module.scss"
import CommonContext from "@src/context"
import task1Image from "@images/season2/mh-task1.jpeg"
import task2Image from "@images/season2/mh-task2.jpeg"
import task3Image from "@images/season2/mh-task3.jpeg"
import mhBgImage from "@images/mh-bg.jpg"
import mhExample1 from "@images/season2/mh-example-1.jpg"
import mhExample2 from "@images/season2/mh-example-2.jpg"

const MonsterHunter = () => {
  const [exampleModalVisible, setExampleModalVisible] = useState(false)
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(mhBgImage)
  }, [])
  return (
    <div>
      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>直播时间</td>
              <td>
                7月9日（周四）20 : 00 开始 A组排位赛
                <br />
                7月10日（周五）20 : 00 开始 B组排位赛
                <br />
                7月11日（周六）20 : 00 开始 C组排位赛、公布排位结果
                <br />
                （ 对竞速排名前12 组选手录像进行直播
                ，所有入围直播选手将额外获得一份随机怪猎盒蛋）
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>
                本次比赛采用视频投稿的形式，进行双人组队斗技场竞速赛
                <br />
                需完成全部3个指定任务
                <br />
                根据游戏内任务计时时间，由快到慢依次排序判定结果
                <br />
                （PC、Xbox One、PS4 平台均可参赛）
                <br />
                <br />
                如需组队请戳这里：
                <a
                  href="https://shimo.im/docs/QPQQx9NpOd0ccKMS/"
                  target="_blank"
                >
                  组队处
                </a>
              </td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>在投稿截止日期前，提交指定斗技场任务的游戏录像</td>
            </tr>
            <tr>
              <td>报名流程</td>
              <td>
                1. 填写赛事报名表；2. 提交后扫码加「选手交流」群；3.
                按照投稿要求录制并进行投稿；4. 关注群内赛事安排信息
              </td>
            </tr>
            <tr>
              <td>投稿要求</td>
              <td>
                1、每个指定任务，需要同时录制两位选手的视角并进行提交
                <br />
                2、每份录像要求必须录制完整（接受任务 — 任务完成 — 拿到赏金 —
                退出任务）
                <br />
                3、为了后期制作，请在录制任务时不要录进去人声哦
                <br />
                <br />
                <Modal
                  isOpen={exampleModalVisible}
                  overlayClassName="modalOverlay"
                  className="modal"
                  onRequestClose={() => {
                    setExampleModalVisible(false)
                  }}
                >
                  <div className={classNames("box box-white")}>
                    <div
                      className="enrollModal"
                      style={{ width: "600px", maxWidth: "100%" }}
                    >
                      <h3>投稿示例</h3>
                      <p>
                        视频录制请从图1「接任务开始录制」，整个过程中请勿录制上玩家对话的语音
                        <br />
                        一直录制到图2「任务结算画面」后出现结算时间为止。
                      </p>
                      <div className={styles.example}>
                        <div>
                          <ClickableImage src={mhExample1} />
                        </div>
                        <div>
                          <ClickableImage src={mhExample2} />
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Clickable
                  onClick={() => {
                    setExampleModalVisible(true)
                  }}
                >
                  戳这里查看「投稿示例」
                </Clickable>
              </td>
            </tr>
            <tr>
              <td>报名、投稿流程</td>
              <td>
                将录制完整的 6 份视频，以邮箱的形式发送到 wen@gcores.com 中
                <br />
                邮箱标题为“队名”；内容需标注：队名、两位选手的昵称、联系方式（手机号+微信号）；
                <br />
                如视频存在问题，我们将在7日内在选手群里与你联系；
                <br />
                投稿时间内可多次提交，以日期最新的有效视频为准。
              </td>
            </tr>
            <tr>
              <td>投稿时间</td>
              <td>6月3日0时 ~ 6月26日0时，过时将不计入最终成绩</td>
            </tr>
            <tr>
              <td>S22资格赛奖励</td>
              <td>
                竞速前四名队伍可获得 SPARK 线上总决赛赛的参赛资格；
                冠军队伍将额外获得 3,000 元的奖金奖励
              </td>
            </tr>
            <tr>
              <td>线上总决赛奖金</td>
              <td>
                冠军 6,000
                <br />
                亚军 3,000
                <br />
                季军 2,000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛任务">
        {/* TODO: 图要换 */}
        <Tasks
          tasks={[
            { image: task1Image, title: "斗技大会大师级 02 —— 眠浮龙" },
            { image: task2Image, title: "斗技大会大师级 04 —— 硫斩龙" },
            { image: task3Image, title: "斗技大会大师级 06 —— 雷狼龙" },
          ]}
        />
      </Section>
      <>
        <Section title="比赛须知">
          <div className="tips">
            <p>
              1. 参赛选手的 ID
              、头像、队伍名称、衣物、携带物品等不得含有违反国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；
            </p>
            <p>
              2.
              参赛选手不得发表违反国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
            </p>
            <p>3. 本次比赛，机核网拥有最终解释权。</p>
          </div>
        </Section>
        <Section title="排名表">
          <div className="tableRank">
            <table>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>队伍名</th>
                  <th>成员</th>
                  <th>猛牛龙</th>
                  <th>迅龙</th>
                  <th>轰龙</th>
                  <th>总成绩</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>TBD</td>
                  <td>TBD member</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>TBD</td>
                  <td>TBD member</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                  <td>00’00’’00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>
        <div className="buttonsContainer">
          <Button
            large
            color="blue"
            href="http://sparkidea.mikecrm.com/F7VVmf2 "
          >
            报名参赛
          </Button>
          <Button
            large
            color="blue"
            href="https://shimo.im/docs/QPQQx9NpOd0ccKMS/ "
          >
            寻找队伍
          </Button>
        </div>
      </>
    </div>
  )
}

export default MonsterHunter
